// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4825) return "static/chunks/4825.9cd2183a3a49fd7f.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4935 ? "e37a0b60" : chunkId) + "-" + {"4935":"8c1fb52c7ea53ed0","7233":"6e0fcd3e4091381f","8199":"77e116a58c985fea"}[chunkId] + ".js";
};